<template>
  <ObPopup 
    v-model="visible"
    position="right"
  >
    <div class="my-circles">
      <BackNav :title="$t('myCircles')" :leftCallBack="hidePage" top="var(--orbit-status-bar-height)">
        <template #right>
          <svg-icon :name="`icon-${drag ? 'done' : 'edit'}`" @click="switchMode"/>
        </template>
      </BackNav>
      <draggable
        v-model="dragList"
        v-bind="dragOptions"
        item-key="id"
        handel=".icon-drag"
        tag="ul"
        :disabled="!drag"
        :component-data="{
          tag: 'ul',
          type: 'transition-group',
          name: !drag ? 'flip-list' : null,
          class: 'view-list'
        }"
      >
        <template #item="{ element }">
          <li class="circle" @click="toCircle(element.id)">
            <div class="circle-item">
              <van-image
                fit="cover"
                :src="element.avatar"
                width="36"
                height="36"
                radius="8"
              />
              <span class="name">{{element.name}}</span>
            </div>
            <svg-icon v-if="drag" class="icon-drag" name="icon-drag" />
          </li>
        </template>
      </draggable>
    </div>
  </ObPopup>
</template>
<script setup>
import { ref, getCurrentInstance, watch, computed } from 'vue'
import { useRouter } from 'vue-router';
import draggable from 'vuedraggable'
import http from '@/service'
const { proxy } = getCurrentInstance()
const router = useRouter()
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  dragList: {
    type: Array,
    default: () => []
  }
})
const visible = ref(false)

const dragList = ref([])
const defaultList = ref([])
const drag = ref(false)
const dragOptions = computed(() => {
  return {
    animation: 200,
    group: "description",
    disabled: false,
    ghostClass: "ghost",
  }
})

// 圈子排序
const switchMode = async () => {
  if (drag.value) {
    const { code, data, msg } = await http.updateCircleOrder(dragList.value.map(i => i.id))
    if (code !== 200 || !data) {
      proxy.$toast({
        message: msg
      })
      dragList.value = defaultList.value
    } else {
      defaultList.value = dragList.value
      drag.value = false
    }
  } else {
    drag.value = true
  }
}

const toCircle = (id) => {
  if (drag.value) return
  router.push({
    name: 'circle',
    params: { id }
  })
}

const hidePage = () => {
  visible.value = false
}
watch(() => props.dragList, (val) => {
  dragList.value = props.dragList
}, {
  immediate: true,
  deep: true,
})
watch(() => props.modelValue, (val) => {
  visible.value = val
})
watch(() => visible.value, (val) => {
  if (!val) {
    emit('update:modelValue', val)
  }
})
</script>
<style lang="postcss" scoped>
.my-circles {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  background: var(--background-body);
  ul {
    padding: 0 20px 20px;
  }
  .view-list {
    padding-top: calc(50px);
    height: calc(100vh - 50px - var(--orbit-status-bar-height));
    overflow: auto;
  }
  .circle {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    &-item {
      flex: 1;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      span {
        margin-left: 16px;
        font-size: 16px;
        max-width: 68vw;
        word-break: break-all;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .svg-icon {
      color: var(--text-hint);
    }
    &:last-child {
      padding-bottom: 40px;
    }
  }
  .ghost {
    opacity: 0 !important;
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
}
</style>